var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"eventadmin",staticStyle:{"position":"absolute","width":"100%"}},[_c('div',{staticClass:"asdf"},[(_vm.event)?_c('h1',[_vm._v("Event Admin")]):_vm._e(),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }